const featuredDealerPreviewImage = new URL(
  "../../shared/images/fd-preview.png",
  import.meta.url,
).href;

/**
 * This component is static and being used in multiple pages in the same fashion.
 * There are future plans to make it dynamic so making it its own component for now.
 */

export const StaticImagePreview = () => {
  return (
    <img
      src={featuredDealerPreviewImage}
      alt="Featured Dealer Preview"
      class="w-full"
    />
  );
};
